export default __webpack_public_path__ + "static/media/rainroad.9126441e.jpg";